import type { ApiThesis } from '../../lib/api'

export function thesisTitle(t: Pick<ApiThesis, 'id' | 'seed'> & { name?: string }): string {
  if (t.name && t.name.trim()) return t.name.trim()
  const seed = t.seed
  if (seed && typeof seed === 'object') {
    const s = seed as Record<string, unknown>
    for (const k of ['name', 'title', 'hypothesis', 'summary']) {
      if (typeof s[k] === 'string' && s[k]) return s[k] as string
    }
  }
  return `Thesis ${t.id.slice(0, 8)}`
}

export type StatusTone = 'neutral' | 'green' | 'red' | 'amber' | 'indigo'

export function statusTone(status: string): StatusTone {
  switch (status) {
    case 'graduated':
      return 'green'
    case 'killed':
      return 'red'
    case 'submitted':
    case 'in_review':
      return 'neutral'
    default:
      return 'indigo'
  }
}

export function statusLabel(status: string): string {
  const s = status.replace(/_/g, ' ')
  return s.charAt(0).toUpperCase() + s.slice(1)
}
